<template>
  <div>
    <!-- 导航栏 -->
    <div>
      <el-header
        class="header"
        style="
          box-shadow: 0px 2px 4px 0px rgba(206, 206, 206, 0.5);
          height: 50px;
          padding-left: 0px;
        "
      >
        <!-- <div class="leftBtn" @click="slideRight">《</div> -->
        <div
          style="
            padding-top: 5px;
            padding-bottom: 5px;
            min-width: 160px;
            background-color: #fff;
            border-right: 1px solid rgba(0, 21, 41, 0.08);
            cursor: pointer;
            display: flex;
          "
          @click="backHome()"
        >
          <img style="height: 40px; margin-left: 4px" src="@/assets/images/logo.png" />
          <div class="title_span" v-if="!getUserInfo">信息管理系统</div>
          <div :title="getUserInfo.showName" class="title_span" v-if="getUserInfo">
            {{ getUserInfo.showName }}
          </div>
        </div>
        <div class="hide-scrollbar">
          <!-- <div class="slider" :style="{ transform: `translateX(${translateX}px)` }"> -->
          <div
            v-for="(item, index) in getMenuList"
            :key="index"
            :style="index == indexes ? 'background-color: #1476c3' : 'color:#1476c3'"
            class="tab-title"
            @click="itemClick(item, index, $event)"
          >
            {{ item.menuName }}
          </div>
          <!-- </div> -->
        </div>
        <!-- <div class="rightBtn" @click="slideLeft">》</div> -->
        <!-- <breadcrumb class="breadcrumb-container" /> -->
        <div class="menu-column" v-if="getMultiColumn" style="margin-left: 20px">
          <el-menu
            mode="horizontal"
            :default-active="getCurrentColumnId"
            @select="onColumnChange"
          >
            <el-menu-item
              v-for="column in getColumnList"
              :key="column.columnId"
              :index="column.columnId"
              >{{ column.columnName }}</el-menu-item
            >
          </el-menu>
        </div>
        <div class="header-menu" style="flex-grow: 1">
          <el-dropdown class="user-dropdown" trigger="click" @command="handleCommand">
            <span class="el-dropdown-link"
              >{{ (getUserInfo || {}).showName
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item class="user-dropdown-item" command="modifyPassword"
                >修改密码</el-dropdown-item
              >
              <el-dropdown-item class="user-dropdown-item" command="modifyHeadImage"
                >修改头像</el-dropdown-item
              >
              <!-- <el-dropdown-item class="user-dropdown-item" command="config"
              >修改配置</el-dropdown-item
            > -->
              <el-dropdown-item class="user-dropdown-item" command="logout"
                >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>

          <img :src="getHeadImageUrl ? getHeadImageUrl : header" class="header-img" />
        </div>
      </el-header>
    </div>
    <!-- 内容 -->
    <el-container :style="getMainStyle">
      <el-aside v-if="!caretStatus" width="160px" class="sidebar">
        <side-bar style="overflow: hidden"></side-bar>
      </el-aside>
      <el-aside width="10px" class="sidebar">
        <div style="line-height: calc(100vh - 95px)">
          <i
            @click="caretStatus = !caretStatus"
            v-if="caretStatus"
            class="el-icon-caret-right caret"
          ></i>
          <i
            @click="caretStatus = !caretStatus"
            v-else
            class="el-icon-caret-left caret"
          ></i>
        </div>
      </el-aside>
      <el-container style="background-color: #f5f8f9">
        <el-main
          :style="{
            'padding-bottom': '10px',
          }"
        >
          <!-- 上方导航栏 -->
          <!-- <div class="title_navigation" :style="'background-color:' + this.$root.color">
            <section class="custom" :style="'background-color:' + this.$root.color">
              <div class="fixed-nav" ref="fixednav">
                <div class="fixed-nav-content">
                  <div
                    v-for="(item, index) in getMenuList"
                    :key="index"
                    :style="index == indexes ? 'background-color: ' + getDarkColor() : ''"
                    :class="['tab-title', indexes === index && 'select-tab']"
                    @click="itemClick(item, index, $event)"
                  >
                    {{ item.menuName }}
                  </div>
                  <div style="clear: both" />
                </div>
              </div>
            </section>
          </div> -->

          <div style="height: 50px; margin-top: 10px; margin-bottom: -6px">
            <tag-panel
              v-if="getMultiTags"
              :tagList="getTagList"
              style="margin: 0px 20px"
            />
          </div>

          <el-scrollbar :style="getContextStyle" wrap-class="scrollbar_dropdown__wrap">
            <transition name="fade" mode="out-in">
              <!--  :include="getCachePages"  sell_outbound_add-->
              <keep-alive :include="getCachePages">
                <router-view
                  style="
                    margin: 0px 10px;
                    background-color: white;
                    overflow: hidden;
                    padding-left: 20px;
                    padding-right: 20px;
                    padding-top: 10px;
                  "
                  :style="getRouterViewStyle"
                />
              </keep-alive>
            </transition>
          </el-scrollbar>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Utils from "@/api/util.js";
import "@/staticDict/flowStaticDict.js";
import SideBar from "./components/sidebar/sidebar.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from "@/core/mixins";
import Breadcrumb from "./components/breadcrumb";
import TagPanel from "./components/tags/tagPanel.vue";
import formModifyPassword from "./components/formModifyPassword/index.vue";
import formModifyHeadImage from "./components/formModifyHeadImage/index.vue";
import { SystemController } from "@/api";
import { getToken, setToken } from "@/utils";
import Vue from "vue";
import OnlineCustomBlock from "@/online/components/OnlineCustomBlock.vue";
import OnlineBaseCard from "@/online/components/OnlineBaseCard.vue";
import OnlineCustomTabs from "@/online/components/OnlineCustomTabs.vue";
import OnlineCustomTableContainer from "@/online/components/OnlineTableContainer/index.vue";
Vue.component("OnlineCustomBlock", OnlineCustomBlock);
Vue.component("OnlineBaseCard", OnlineBaseCard);
Vue.component("OnlineCustomTabs", OnlineCustomTabs);
Vue.component("OnlineCustomTableContainer", OnlineCustomTableContainer);

export default {
  data() {
    return {
      excludeRegexes: [/_add$/, /_details$/], // 正则表达式数组
      header: require("../../assets/img/default-header.jpg"),
      indexes: 0, // 索引
      caretStatus: false,
      messageCount: this.$root.messageCount,
      translateX: 0,
      step: 90, // 每次滑动的距离
    };
  },
  components: {
    "side-bar": SideBar,
    breadcrumb: Breadcrumb,
    "tag-panel": TagPanel,
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    // 返回首页
    backHome() {
      this.setCurrentMenuId(undefined);
    },
    getList() {
      if (sessionStorage.getItem("layoutIndex")) {
        let index = sessionStorage.getItem("layoutIndex");
        this.indexes = Number.parseInt(index);
        this.$root.route_path = [this.getMenuList[sessionStorage.getItem("layoutIndex")]];
      } else {
        this.$root.route_path = [this.getMenuList[0]];
        sessionStorage.setItem("layoutIndex", 0);
      }
    },
    changeTab(id, event) {
      // 如果选择的和当前激活的不同
      if (id !== this.indexes) {
        // 计算当前按钮的位置，看是否需要移动
        const spanLeft = event.clientX; // 当前点击的元素左边距离
        const divBox = document.querySelector(".select-tab").clientWidth / 2; // 点击的元素一半宽度
        const totalWidths = document.body.clientWidth; // 屏幕总宽度
        const widths = totalWidths / 2; // 一半的屏幕宽度
        const spanRight = totalWidths - spanLeft; // 元素的右边距离
        const scrollBox = document.querySelector(".fixed-nav"); // 获取最外层的元素
        const scrollL = scrollBox.scrollLeft; // 滚动条滚动的距离
        // 当元素左边距离 或者 右边距离小于100时进行滑动
        if (spanRight < 150 || spanLeft < 150) {
          scrollBox.scrollLeft = scrollL + (spanLeft - widths) + divBox;
        }
      }
    },
    // hex颜色转rgb颜色
    HexToRgb(str) {
      var r = /^\#?[0-9A-F]{6}$/;
      // test方法检查在字符串中是否存在一个模式，如果存在则返回true，否则返回false
      if (!r.test(str)) return window.alert("输入错误的hex");
      // replace替换查找的到的字符串
      str = str.replace("#", "");
      // match得到查询数组
      var hxs = str.match(/../g);
      // alert('bf:'+hxs)
      for (var i = 0; i < 3; i++) hxs[i] = parseInt(hxs[i], 16);
      // alert(parseInt(80, 16))
      return hxs;
    },
    // GRB颜色转Hex颜色
    RgbToHex(a, b, c) {
      var r = /^\d{1,3}$/;
      if (!r.test(a) || !r.test(b) || !r.test(c)) {
        return window.alert("输入错误的rgb颜色值");
      }
      var hexs = [a.toString(16), b.toString(16), c.toString(16)];
      for (var i = 0; i < 3; i++) if (hexs[i].length == 1) hexs[i] = "0" + hexs[i];
      return "#" + hexs.join("");
    },
    // 得到hex颜色值为color的加深颜色值，level为加深的程度，限0-1之间
    getDarkColor() {
      let color = this.$root.color.toUpperCase();
      let level = 0.2;
      var r = /^\#?[0-9A-F]{6}$/;
      if (!r.test(color)) return this.$root.color;
      var rgbc = this.HexToRgb(color);
      // floor 向下取整
      for (var i = 0; i < 3; i++) rgbc[i] = Math.floor(rgbc[i] * (1 - level));
      return this.RgbToHex(rgbc[0], rgbc[1], rgbc[2]);
    },
    itemClick(item, index, event) {
      // this.changeTab(index, event);
      this.caretStatus = false;
      this.$root.route_path = [];
      this.$root.route_path = [item];
      this.indexes = index;
      sessionStorage.setItem("layoutIndex", this.indexes);
    },
    toggleSideBar() {
      this.setCollapse(!this.getCollapse);
    },
    onColumnChange(columnId) {
      this.setCurrentColumnId(columnId);
      this.clearCachePage();
      this.$router.replace({
        name: "welcome",
      });
    },
    resetDocumentClientHeight() {
      let timerID;
      let _this = this;
      return function () {
        clearTimeout(timerID);
        timerID = setTimeout(() => {
          var h = document.documentElement["clientHeight"];
          var w = document.documentElement["clientWidth"];
          _this.setClientHeight(h);
          _this.setClientWidth(w);
        }, 50);
      };
    },
    handleCommand(command) {
      if (command === "logout") {
        this.$confirm("是否退出登录？", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let options = {
              headers: {
                Authorization: getToken(),
              },
              showMask: false,
            };
            // SystemController.logout(this, {}, options).catch((e) => {});
            this.clearAllTags();
            setToken();
            sessionStorage.removeItem("layoutIndex");
            window.sessionStorage.removeItem("isUaaLogin");
            this.$router.replace({ name: "login" });
          })
          .catch((e) => {});
      } else if (command === "modifyPassword") {
        this.$dialog
          .show(
            "修改密码",
            formModifyPassword,
            {
              area: ["500px"],
            },
            {}
          )
          .catch((e) => {});
      } else if (command === "modifyHeadImage") {
        this.$dialog
          .show(
            "修改头像",
            formModifyHeadImage,
            {
              area: ["500px"],
            },
            {}
          )
          .catch((e) => {});
      }
      // else if (command === "config") {
      //   this.$router.push({
      //     path: "/main/system_configuration",
      //     query: {},
      //   });
      // }
    },
    handleMessage(type) {
      this.onMoreMessageClick(type);
    },
    // 更多催办消息
    onMoreMessageClick(type) {
      this.$router.push({
        name: "formMessage",
        query: {
          type: type,
        },
      });
    },
    ...mapMutations([
      "setClientHeight",
      "setClientWidth",
      "setCurrentColumnId",
      "setCurrentMenuId",
      "clearCachePage",
      "clearAllTags",
      "setUserInfo",
      "setMenuList",
    ]),
    ...mapActions(["startMessage", "stopMessage"]),
  },
  computed: {
    getMainStyle() {
      return [{ height: this.getClientHeight - 51 + "px" }];
    },
    getContextStyle() {
      return [{ height: this.getMainContextHeight + 15 - 32 + 46 + "px" }];
    },
    getRouterViewStyle() {
      return [{ "min-height": this.getMainContextHeight + 15 - 32 + 46 + "px" }];
    },
    getHeadImageUrl() {
      if (
        this.getUserInfo &&
        this.getUserInfo.headImageUrl != null &&
        this.getUserInfo.headImageUrl !== ""
      ) {
        let temp = this.getUploadFileUrl(this.getUserInfo.headImageUrl, {
          filename: this.getUserInfo.headImageUrl.filename,
        });
        return temp;
      } else {
        return null;
      }
    },
    ...mapGetters([
      "getMultiTags",
      "getClientHeight",
      "getUserInfo",
      "getCollapse",
      "getCachePages",
      "getTagList",
      "getMultiColumn",
      "getCurrentColumnId",
      "getColumnList",
      "getMenuItem",
      "getMenuList",
      "getMainContextHeight",
    ]),
  },
  mounted() {
    let resetHeight = this.resetDocumentClientHeight();
    resetHeight();

    window.onresize = () => {
      resetHeight();
    };
    // 重新获取登录信息
    if (getToken() != null && getToken() !== "" && this.getUserInfo == null) {
      SystemController.getLoginInfo(this, {})
        .then((data) => {
          this.setMenuList(data.data.menuList);
          delete data.data.menuList;
          this.setUserInfo(data.data);
        })
        .catch((e) => {});
    }

    // 获取催办消息
    this.startMessage(this);

    // 获取最新消息数量
    var that = this;
  },

  watch: {
    getMenuItem: {
      handler(newValue) {
        // 登录成功跳转默认页
        if (newValue == null) {
          if (this.$route.name !== "welcome") {
            this.$router.replace({
              name: "welcome",
            });
          }
          // this.$router.push({
          //   path: "/main/customer_customer",
          //   query: {},
          // });
          //  this.$router.push({
          //   path: "/main/welcome",
          //   query: {},
          // });
          return;
        }
        // 路由跳转
        this.$router.replace({
          name: newValue.formRouterName,
        });
      },
      immediate: true,
    },
  },
  beforeRouteLeave(to, form, next) {
    this.stopMessage();
    next();
  },
  destoryed() {
    this.stopMessage();
  },
};
</script>

<style lang="scss">
.caret {
  background-color: #e6e6e6;
  padding: 50px 0px;
  cursor: pointer;
  border-top-right-radius: 100%;
  border-bottom-right-radius: 100%;
}

.el_msg {
  height: 18px;
  line-height: 18px;
  cursor: pointer;
  margin-top: 7px;
  margin-right: 6px;
}

.message-popover {
  padding: 5px !important;
}

.message-popover .el-table::before {
  height: 0px !important;
}

.message-popover .el-table td {
  border: none;
}

// 自定义
.title_navigation {
  width: calc(100vw - 360px);
  height: 32px;
  line-height: 32px;
  float: left;
}

.title_span {
  font-size: 14px;
  height: 32px;
  margin-left: 10px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  color: #283440;
  padding-top: 10px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出的内容 */
  text-overflow: ellipsis; /* 超出部分用省略号表示 */
  width: 100px;
}

.custom {
  height: 32px;
  width: 100%;
  position: absolute;
  top: 50px;
  z-index: 999;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -moz-user-select: none;
  /* Firefox私有属性 */
  -webkit-user-select: none;
  /* WebKit内核私有属性 */
  -ms-user-select: none;
  /* IE私有属性(IE10及以后) */
  -khtml-user-select: none;
  /* KHTML内核私有属性 */
  -o-user-select: none;
  /* Opera私有属性 */
  user-select: none;
  /* CSS3属性 */
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  height: 1em !important;
  // z-index: 1000 !important;
  // width: 0.01rem;
  // opacity: 0;
  // display: none;
}

.scroll-x::-webkit-scrollbar {
  height: 0.6em !important;
  // z-index: 1000 !important;
  // width: 0.01rem;
  // opacity: 0;
  // display: none;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  background-color: #fff;
  opacity: 0;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  width: 0.01rem;
  border-radius: 0.01rem;
  opacity: 0;
}

.theme-list {
  margin-top: 12px;
  border: 1px solid red;
}

.fixed-nav {
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}

.fixed-nav-content {
  display: flex;
}

.tab-title {
  cursor: pointer;
  line-height: 50px;
  text-align: center;
  color: #fff;
  font-size: 15px;
  padding-left: 30px;
  padding-right: 30px;
}

span.tab-title {
  color: #555;
}

.rect-printElement-types .hiprint-printElement-type > li > .title {
  display: block;
  padding: 0 5px !important;
  text-align: left;
  clear: both;
  margin: 5px 0;
  border-left: 5px #aff solid;
}
/* 为外层容器添加一个类名，例如 'hide-scrollbar' */
.hide-scrollbar::-webkit-scrollbar {
  display: none; /* 针对Chrome, Safari等使用WebKit引擎的浏览器 */
}

/* 对于Firefox，可以尝试使用以下方法隐藏滚动条 */
.hide-scrollbar {
  scrollbar-width: none; /* Firefox */
  height: 50px;
  width: 66vw;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  margin-left: 10px;
}
// 顶部按钮左右动
.slider-container {
  position: relative;
  height: 50px;
  width: 66vw;
  overflow: hidden;
}
.slider {
  transition: transform 0.3s ease;
  display: flex;
  /* 其他样式 */
}
.leftBtn {
  cursor: pointer;
}
.rightBtn {
  cursor: pointer;
}
.userName {
  color: #00988b;
  margin: 0px 6px;
  cursor: pointer;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出的内容 */
  text-overflow: ellipsis; /* 超出部分用省略号表示 */
}
</style>
